import { CampaignDto } from '@shared/services/apiService';
import { CampaignRunStatusType } from '@shared/services/apiService/missing-types';
import { CampaignStatus } from './CampaignStatusButton';

type CampaignStatusValue = CampaignDto['status'] | CampaignRunStatusType.FINISHING;
type CampaignForStatus = { status?: CampaignStatusValue | null } | null | undefined;

export const getCampaignStatus = (campaign: CampaignForStatus): CampaignStatus => {
  if (campaign?.status === CampaignRunStatusType.FINISHING) return CampaignStatus.Stopping;
  if (campaign?.status === CampaignRunStatusType.ACTIVE) return CampaignStatus.Dialing;
  return CampaignStatus.NotStarted;
};
